import { render, staticRenderFns } from "./closed.vue?vue&type=template&id=374e86cc&scoped=true&"
import script from "./closed.vue?vue&type=script&lang=js&"
export * from "./closed.vue?vue&type=script&lang=js&"
import style0 from "./closed.vue?vue&type=style&index=0&id=374e86cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374e86cc",
  null
  
)

export default component.exports